import { createNamedContext } from '@utils';
import { SurveyVersion } from '@/types';

export const SurveyContext = createNamedContext<SurveyVersion>(null!, 'SurveyContext');